export default {
  tabs: {
    profile: 'Profil',
    branding: 'Identité visuelle',
    domain: 'Domaine',
    earning: 'Revenus',
    feature_flags: 'Indicateurs de fonctionnalités',
    notification_channels: 'Canaux de notification',
    pricing: 'Tarification',
    fees: 'Frais',
    payments: 'Paiements',
    billing: 'Facturation',
  },
  earning: {
    internal_notice: 'Paramètres FoodAmigos uniquement. Non visibles par le partenaire.',
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur.',
    editing_notice: 'Modification — les changements affectent les calculs de versement réels.',
  },
  fees: {
    internal_notice:
      'Paramètres réservés à FoodAmigos. Non visibles par le partenaire, cet onglet ne peut être ouvert que par les super administrateurs. Les modifications affectent ce qui est facturé aux clients et ce que la plateforme perçoit.',
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur de cet onglet.',
    editing_notice:
      "Modification — Enregistrer applique à la fois les frais de service et les taux de traitement. Les taux s'appliquent à partir de la prochaine charge ; les transactions antérieures conservent la marge qui leur a été appliquée.",
  },
  profile: {
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur.',
    editing_notice: 'Modification — le nom affiché est visible par les clients.',
    form: {
      name: {
        label: 'Nom du partenaire',
        hint: "Le nom légal / de l'entité. Utilisé en interne et sur les documents de facturation.",
      },
      display_name: {
        label: 'Nom affiché aux clients',
        hint: 'Le libellé « Propulsé par ___ » affiché aux clients. Par défaut, le nom du partenaire si laissé vide.',
      },
      admin_email: {
        label: 'E-mail admin',
        hint: "Le compte admin invité. Non modifiable ici — contactez l'équipe technique pour déplacer le compte.",
      },
      invoicing_emails: {
        label: 'E-mails de facture',
        hint: "Les reçus des factures facturées à ce partenaire sont envoyés à chacune de ces adresses. Laissez vide pour utiliser l'e-mail de l'administrateur.",
        placeholder: 'E-mail admin',
      },
      status: {
        label: 'Statut',
        hint: "Les partenaires invités deviennent actifs à leur première connexion — l'activation manuelle ignore cette étape. La suspension désactive tous les accès de l'équipe du partenaire.",
      },
      region: {
        label: 'Région',
        hint: "Le pays est fixe. Choisissez un état si les restaurants du partenaire suivent les règles fiscales d'État — cela ne modifie que les paramètres par défaut du partenaire, pas les restaurants existants.",
      },
      messenger_audience: {
        label: "Chat d'assistance",
        hint: "Qui, sous ce partenaire, a accès au chat d'assistance FoodAmigos. Le personnel FoodAmigos y a toujours accès. Les partenaires en marque blanche assistent leurs propres restaurants, donc seuls leurs admins y ont accès.",
        options: {
          everyone: 'Tout le monde, restaurants inclus',
          partner_admins: 'Admins du partenaire uniquement',
          nobody: 'Personne',
        },
      },
      shop_domains: {
        label: 'Domaines de boutique',
        hint: 'Domaines racines sur lesquels les boutiques du partenaire sont servies. Le domaine principal est utilisé pour les nouvelles marques. Le partenaire connecte et dissocie lui-même ses propres domaines de boutique ; l’onglet Domaine affiche leurs enregistrements DNS.',
      },
    },
    region: {
      whole_country: 'Pays entier',
    },
    shop_domains: {
      primary: 'Principal',
      platform_default: 'Défaut de la plateforme',
      empty: "Aucun domaine de boutique lié pour l'instant",
    },
    statuses: {
      invited: 'Invité',
      active: 'Actif',
      suspended: 'Suspendu',
    },
    custody: {
      label: 'Traitement des paiements',
      not_configured: 'Pas encore configuré',
      provider: 'Passerelle propre au partenaire',
      platform: 'FoodAmigos traite les paiements',
      bank_account: {
        set: 'Compte bancaire : {{label}} ({{status}})',
        missing: 'Aucun compte bancaire pour l’instant. Le partenaire le saisit dans Facturation partenaire.',
        statuses: {
          active: 'actif',
          pending_verification: 'en cours de vérification',
          action_needed: 'action requise',
          errored: 'échec du virement',
          missing: 'manquant',
        },
      },
      hint: "Déterminé par la configuration des paiements dans l'onglet Paiements, et verrouillé une fois un mode de paiement enregistré. Avec le traitement FoodAmigos, la part de revenus du partenaire est versée mensuellement.",
      kyc: {
        label: 'Compte de versement',
        missing: 'Pas encore créé',
        incomplete: 'Vérification incomplète',
        complete: 'Prêt pour les versements',
        currently_due: 'Stripe a encore besoin de : {{fields}}',
        send_link: "Envoyer le lien d'inscription",
        link_copied:
          "Lien d'inscription copié dans le presse-papiers — transmettez-le au partenaire. Il est à usage unique et expire.",
        link_ready: "Lien d'inscription — transmettez-le au partenaire (usage unique, expire)",
        link_failed: "Impossible de créer le lien d'inscription.",
      },
    },
    suspend_confirm: {
      title: 'Suspendre ce partenaire ?',
      description:
        "Tous les membres de l'équipe du partenaire seront désactivés et leurs sessions révoquées. Leurs restaurants restent en ligne.",
    },
  },
  branding: {
    read_only_notice: 'Lecture seule. Cliquez sur Modifier pour changer une valeur.',
    editing_notice: 'Modification — les changements sont visibles sur les interfaces en marque blanche du partenaire.',
    upload: 'Télécharger le logo',
    logo: {
      label: 'Logo',
      hint: 'Affiché sur les interfaces en marque blanche du partenaire.',
    },
    circle_logo: {
      label: 'Favicon / logo circulaire',
      hint: 'Logo carré utilisé comme favicon et avatar. Facultatif — peut être supprimé.',
    },
    splash_image: {
      label: 'Image de connexion',
      hint: 'Remplit la moitié gauche de la page de connexion en marque blanche du partenaire de bord à bord (cover). Recommandé : portrait, 1200×1200px minimum. Facultatif — peut être supprimée.',
    },
    footer_note: "D'autres options d'identité visuelle (couleurs secondaires) seront disponibles prochainement.",
  },
  revenue_split: {
    title: 'Partage des revenus',
    description:
      "Définissez la part du partenaire sur chaque frais collecté par FoodAmigos sur les commandes de ses restaurants. Par défaut 0 % — FoodAmigos conserve la totalité jusqu'à l'attribution d'une part. Versée à chaque cycle de facturation.",
    manage_on_fees: "Gérer dans l'onglet Frais",
    split: 'Partenaire {{partner}}% · FoodAmigos {{platform}}%',
    rows: {
      processing: 'Frais de traitement',
      gift_card: 'Frais carte cadeau',
      delivery: 'Frais de livraison',
      service_fee: 'Frais de service',
    },
    notes: {
      service_fee:
        "Le montant facturé aux clients est défini dans Contrôles des frais de service, sous l'onglet Frais.",
    },
  },
  service_fee_controls: {
    title: 'Contrôles des frais de service',
    description: 'Ce que le partenaire facture à ses clients comme frais de service en supplément de la commande.',
    zero_percentage_warning:
      'Un pourcentage de 0 % ne désactive pas les frais de service : les frais calculés inférieurs au minimum sont arrondis à ce montant, donc chaque commande est facturée au moins le minimum.',
  },
  hard_limits: {
    title: 'Limites strictes',
    description:
      "Plafonds FoodAmigos appliqués à l'enregistrement et au paiement. Aucun frais de service pour ce partenaire — y compris par restaurant — ne peut dépasser ces limites.",
    max_percentage: {
      label: '% de frais de service maximum',
      help: 'Les frais de service du partenaire ne peuvent pas dépasser ce seuil. Limite plateforme : 5 %.',
    },
    min_amount: {
      label: 'Montant minimum des frais de service',
      help: 'Les minimums par restaurant ne peuvent pas être inférieurs à ce montant.',
    },
    max_amount: {
      label: 'Montant maximum des frais de service',
      help: 'Plafond absolu des frais de service fixes, quel que soit le pourcentage.',
    },
  },
  form: {
    charges_service_fee_on_site: {
      label: 'Facturer les frais de service sur les commandes à table',
      description:
        'Valeur par défaut des restaurants de ce partenaire ; chacun peut définir la sienne. Désactivé : les commandes à table ne paient pas de frais de service.',
    },
    is_service_fee_change_allowed: {
      label: 'Autoriser des frais de service différents par restaurant',
      description: "Permet à chaque restaurant du partenaire d'utiliser des frais de service différents.",
    },
    service_fee_platform_share: {
      label: 'Part de Foodamigos sur les frais de service',
    },
    recommended: 'Recommandé : {{value}}',
    service_fee_percentage: {
      label: 'Pourcentage de frais de service par défaut',
      help: 'Appliqué à chaque restaurant du partenaire sauf dérogation.',
    },
    min_service_fee_amount: {
      label: 'Montant minimum des frais par défaut',
      help: 'Minimum par défaut par commande — les frais calculés inférieurs sont arrondis. Les restaurants peuvent définir le leur dans les limites FoodAmigos.',
    },
    max_service_fee_amount: {
      label: 'Montant maximum des frais par défaut',
      help: 'Plafond par défaut par commande — les restaurants peuvent définir le leur dans les limites FoodAmigos.',
    },
    primary_color: {
      label: 'Couleur principale de la marque',
    },
    dashboard_subdomain: {
      label: 'Slug de connexion partenaire',
      hint: "Slug en minuscules — identifie la marque du partenaire dans son lien de connexion d'équipe (?partner=…).",
      placeholder: 'partner-name',
    },
    login_url: {
      label: "Lien de connexion de l'équipe",
      hint: "Le lien que l'équipe du partenaire utilise pour accéder à sa page de connexion personnalisée.",
    },
    file: {
      label: 'Image',
    },
  },
  buttons: {
    edit: 'Modifier',
    cancel: 'Annuler',
    save: 'Enregistrer',
  },
  toasts: {
    load_error: 'Impossible de charger les paramètres.',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
    logo_uploaded: 'Logo téléchargé',
    logo_upload_failed: 'Échec du téléchargement du logo',
    logo_removed: 'Logo supprimé',
    logo_remove_failed: 'Échec de la suppression du logo',
    file_too_large: 'Fichier trop volumineux. La taille maximale est de {{max}} Mo.',
    image_too_narrow: "L'image de connexion doit faire au moins {{min}}px de large.",
  },
  notification_channels: {
    master_locked:
      'Le partenaire maître envoie pour chaque restaurant de la plateforme, ses canaux ne peuvent donc pas être modifiés ici.',
    unavailable: 'Les canaux de notification ne sont pas encore disponibles sur ce backend.',
    notice:
      'Paramètre interne. Un partenaire sans compte Twilio propre doit rester en e-mail uniquement : sinon, chaque SMS, message WhatsApp et appel vocal passerait par le compte Twilio de FoodAmigos.',
    forbidden: 'Seuls les super administrateurs peuvent modifier les canaux de notification.',
    columns: {
      channel: 'Canal',
      status: 'Activé',
    },
    channels: {
      email: {
        name: 'E-mail',
        description: 'Toujours actif, pour que le partenaire et ses restaurants soient toujours joignables.',
      },
      sms: {
        name: 'SMS',
        description: 'Mises à jour de commande et codes de connexion aux clients par SMS.',
      },
      whatsapp: {
        name: 'WhatsApp',
        description: 'Alertes aux propriétaires de restaurant et codes de connexion aux clients via WhatsApp.',
      },
      voice_call: {
        name: 'Appels vocaux',
        description: "Appels de rappel pour les commandes en attente et prise d'appels.",
      },
      push: {
        name: 'Notifications push',
        description:
          "Notifications push aux clients et à l'application tableau de bord du propriétaire. Les alertes tablette du personnel ne sont pas concernées.",
      },
    },
    toasts: {
      load_error: 'Impossible de charger les canaux de notification.',
      error: "Impossible d'enregistrer les canaux de notification.",
      saved: 'Canaux de notification enregistrés.',
    },
  },
  feature_flags: {
    internal_notice:
      'Paramètres réservés à FoodAmigos. Non visibles par le partenaire. Les modifications prennent effet immédiatement.',
    read_only:
      "Lecture seule — modifier la facturation des restaurants nécessite un déploiement coordonné, pas un simple switch. Contactez l'équipe technique.",
    forbidden: 'Seuls les super administrateurs peuvent gérer les indicateurs de fonctionnalités des partenaires.',
    columns: {
      feature: 'Fonctionnalité',
      status: 'Statut',
    },
    flags: {
      external_printer: {
        name: 'Imprimante à reçus externe',
        description:
          "Le paramètre par défaut pour les restaurants que ce partenaire intègre à partir de maintenant : chaque nouveau restaurant peut désormais connecter une imprimante à reçus réseau à l'application de terminal de commande. Les restaurants existants conservent leurs propres réglages de l'onglet Feature Flags, et chaque restaurant peut toujours être basculé individuellement à cet endroit.",
      },
      plg_onboarding: {
        name: 'Intégration en libre-service (PLG)',
        description:
          "Onboarding en libre-service pour partenaires : offre à ce partenaire la page « Nouveau restaurant » guidée et l'assistant d'onboarding au lieu de la fenêtre Ajouter une entreprise classique et de l'assistant Démarrage, masque les éléments réservés à FoodAmigos et ceux pas encore applicables pour le partenaire et ses restaurants, et bloque la première mise en ligne jusqu'à ce qu'une date de lancement soit convenue. Activé pour chaque nouveau partenaire.",
      },
      issue_end_customer_receipts: {
        name: 'Factures client final',
        description:
          'Permet aux clients de demander une facture lors du paiement et de la recevoir par e-mail. Désactivé pour les nouveaux partenaires ; les règles de format de facture internationales rendent la prise en charge coûteuse.',
      },
      merchant_billing: {
        name: 'Facturation des restaurants',
        description:
          "Facture les restaurants du partenaire via la plateforme. Désactivé signifie qu'ils règlent en dehors.",
      },
      cuisine_backfill: {
        name: 'Remplissage automatique des cuisines',
        description: 'Autorise le remplissage automatique du type de cuisine pour les restaurants de ce partenaire.',
      },
      image_backfill: {
        name: 'Remplissage automatique des images',
        description: 'Autorise le remplissage automatique des images de menu pour les restaurants de ce partenaire.',
      },
      auto_image_generation: {
        name: "Génération automatique d'images",
        description: 'Génère des images de menu à la demande pour les restaurants de ce partenaire.',
      },
      provider_billing: {
        name: 'Facturation des partenaires par Foodamigos',
        description:
          'Inclut ce partenaire dans la facturation Foodamigos. Désactivé signifie que le partenaire est facturé hors plateforme. Active aussi PayPal (direct) pour les restaurants de ce partenaire, avec les frais de service appliqués dessus.',
      },
      partner_custom_dashboard_domain: {
        name: 'Domaine de tableau de bord dédié',
        description:
          'Permet à ce partenaire de connecter son propre domaine pour le tableau de bord, afin que son équipe et ses restaurants se connectent via l’adresse du partenaire. Activer ou désactiver cette option modifie tous les liens du tableau de bord envoyés par la plateforme pour ce partenaire.',
      },
      partner_custom_shop_domain: {
        name: 'Domaine de boutique propre',
        description:
          'Permet à ce partenaire de connecter son propre domaine pour les boutiques en ligne de ses restaurants, sous lequel chaque restaurant reçoit sa propre adresse. À activer partenaire par partenaire : cela change l’adresse utilisée par les clients.',
      },
      partner_legal_documents: {
        name: 'Documents juridiques du partenaire',
        description:
          'Génère les mentions légales, la politique de confidentialité et les conditions générales des boutiques de ce partenaire à partir des informations juridiques propres à chaque restaurant. Désactivé, ou si les informations d’un restaurant sont incomplètes, les boutiques affichent les documents standards de la plateforme.',
      },
    },
    toasts: {
      load_error: 'Échec du chargement des indicateurs de fonctionnalités',
      error: "Échec de la modification de l'indicateur de fonctionnalité",
      enabled: 'Fonctionnalité activée',
      disabled: 'Fonctionnalité désactivée',
    },
  },
};
